import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';

export const path = '/';

const PageHome: React.FC = (props) => {
  const LoadableMap = Loadable.Map({
    loader: {
      page: () => import(`./page`),
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}): React.ReactNode {
      const Page: any = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <LoadableMap {...props} />;
};

export default PageHome;
